import React, {useState} from "react";
import FormView from "../components/FormView";
import {useAlert} from "../components/hooks";

import * as API from "../util/api";
import * as Util from "../util/util";
import {CenteredPaper, VLScreen2} from "./VLScreen2";

const Screen = ({subcontractor, onSave, onUpdate}) => {

    const items = [
        {type: "title", text: "Subcontractor"},
        {type: "text", name: "Name", value: subcontractor.name, id: "name"},
        {type: "text", name: "Email", value: subcontractor.email, id: "email"},
        {type: "button", text: "Save", onClick: onSave}
    ];

    return (
        <CenteredPaper>
            <div style={{overflowY: "auto", height: "100%", padding: 16}}>
                <FormView questionWidth={180} items={items} changed={onUpdate}/>
            </div>
        </CenteredPaper>
    );
};

const Container = ({id}) => {

    const [subcontractor, setSubcontractor] = useState({name: "", email: ""});

    const [alertComponent, showBasicAlert, showAlert] = useAlert();

    const save = () => {
        const params = {...subcontractor};

        showAlert("Loading", "Please wait");
        API.POST(`subcontractors/add`, params, result => {
            if (result.success) {
                showBasicAlert(`Subcontractor has been added. Their login details have been emailed to them.`, Util.goBack);
            } else {
                showBasicAlert(result.error);
            }
        });
    };

    const onUpdate = (key, value) => setSubcontractor({...subcontractor, [key]: value});

    return (
        <VLScreen2 title={"Add Subcontractor"} loaded={true}>
            {alertComponent}
            <Screen subcontractor={subcontractor} onSave={save} onUpdate={onUpdate}/>
        </VLScreen2>
    );
};

export default Container;